module.exports = __webpack_public_path__ + "static/media/ic-insta.58dd7e81.svg";